import { Clickable } from 'dg-web-shared/ui/Clickable.tsx';
import { Option } from './Option.ts';
import { HalfSlideIn, SecondLevelHeader, SlideInBody } from './Slidein.tsx';
import { css } from '@emotion/css';
import { OperatorTypo } from '../OperatorTypo.ts';
import { ColorHex } from '../Colors.ts';
import React, { type JSX } from 'react';

export type { Option } from './Option.ts';

export interface SingleSelectionSlideInProps<I> {
    open: boolean;
    heading: React.ReactNode;
    selection: I | null;
    options: Option<I>[];
    onLeftActionClick: () => void;
    onSelect: (value: I) => void;
    outsideBody?: boolean;
}

export function GenericSingleSelectionSlideIn<I>({
    open,
    heading,
    selection,
    options,
    onLeftActionClick,
    onSelect,
    outsideBody,
}: SingleSelectionSlideInProps<I>) {
    function renderElements(): JSX.Element[] {
        return options.map((o: Option<I>) => {
            return (
                <Clickable
                    key={JSON.stringify(o.id)}
                    element="div"
                    disabled={o.disabled}
                    className={css([
                        {
                            ...OperatorTypo.headingOne,
                            fontWeight: 500,
                            lineHeight: '2em',
                            padding: '4px 48px',
                            margin: '0 -48px',
                            color: ColorHex.rgba(
                                ColorHex.darkblue,
                                o.disabled ? 0.4 : 0.8,
                            ),
                            '&:hover': o.disabled
                                ? undefined
                                : {
                                      background: ColorHex.darkblue,
                                      color: ColorHex.white,
                                  },
                        },
                        o.id === selection && {
                            color: ColorHex.rgba(ColorHex.darkblue, 0.8),
                            background: ColorHex.rgba(ColorHex.darkblue, 0.2),
                            '&:hover': o.disabled
                                ? undefined
                                : {
                                      background: ColorHex.darkblue,
                                      color: ColorHex.white,
                                  },
                        },
                    ])}
                    onClick={() => !o.disabled && onSelect(o.id)}
                >
                    {o.displayText}
                </Clickable>
            );
        });
    }

    return (
        <HalfSlideIn open={open} outsideBody={outsideBody || false}>
            <SecondLevelHeader onClose={onLeftActionClick} title={heading} />
            <SlideInBody>{renderElements()}</SlideInBody>
        </HalfSlideIn>
    );
}

// generic components crap, see https://github.com/Microsoft/TypeScript/issues/3960

export const NumberSingleSelectionSlideIn: (
    p: SingleSelectionSlideInProps<number>,
) => JSX.Element = GenericSingleSelectionSlideIn;

export const StringSingleSelectionSlideIn: (
    p: SingleSelectionSlideInProps<string>,
) => JSX.Element = GenericSingleSelectionSlideIn;
